<template>
  <div class="edit-toggle-switch-input my-1">
    <label>Schalter</label>

    <div class="input-wrapper">
      <div class="input-group">
        <input v-model="element.value" type="radio" :value="true" />
        <label>Aktiv</label>
      </div>
      <div class="input-group">
        <input v-model="element.value" type="radio" :value="false" />
        <label>Inaktiv</label>
      </div>
    </div>
    <!-- <InputSwitch
      v-model="element.value"
      :elementId="element.id"
      :tabIndex="element?.settings?.tabindex"
    /> -->
  </div>
</template>

<script>
import InputSwitch from '@/components/FormBuilder/core/InputSwitch.vue';
export default {
  name: 'ToggleSwitchEditElement',
  props: {
    element: {
      type: Object,
      required: true,
    },
  },
  components: {
    InputSwitch,
  },
};
</script>

<style scoped>
.edit-toggle-switch-input label {
  font-size: 13px;
  font-family: Open Sans, open-sans, sans-serif;
  color: #464d5d;
}
.edit-toggle-switch-input .input-wrapper {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
  margin-left: 12px;
  gap: 6px;
}
.edit-toggle-switch-input .input-group {
  display: flex;
  align-items: center;
  gap: 20px;
}
.edit-toggle-switch-input .input-group input {
  width: 20px;
}
</style>
